import { setLoading } from "../generalActions/mainActions";
import { changeListItem, removeItem, setItems, setItem } from "../generalActions/subFormActions";
import {afiPickupScheduleService} from "../../../jwt/_services/hotel/afiPickupScheduleService";

export const search = (pageIndex, pageSize, filter, callBack = () => {}) => ( dispatch ) => {
    dispatch(setLoading(true))

    afiPickupScheduleService.search(pageIndex, pageSize, filter)
        .then(result => {
            if (!result)
                return

            dispatch(setItems(result))
        })
        .finally(() => {
            callBack(false)
            dispatch(setLoading(false))
        })
}

export const syncFirebase = ( data ) => ( dispatch ) => {
    dispatch(setLoading(true))

    afiPickupScheduleService.syncFirebase(data)
        .then(result => {
            if (!result)
                return
        })
        .finally(() => dispatch(setLoading(false)))
}

export const save = (data, callBack = () => {}) => ( dispatch ) => {
    dispatch(setLoading(true))

    afiPickupScheduleService.saveItem(data)
        .then( result => {
            if(!result)
                return

            dispatch(setItems(result))
        })
        .finally(() => {
            callBack(false)
            dispatch(setLoading(false))
        })
}

export const update = (id, data) => ( dispatch ) => {
    dispatch(setLoading(true))

    afiPickupScheduleService.updateItem(id, data)
        .then( result => {
            if(!result)
                return

            dispatch( setItem(result) )
            dispatch( changeListItem(result) )
        })
        .finally(() => dispatch(setLoading(false)))
}

export const remove = (id, fbDataBaseId, callBack =() => {}) => ( dispatch ) => {
    dispatch(setLoading(true))

    afiPickupScheduleService.deleteItem(id, fbDataBaseId)
        .then( result => {
            if(result?.status)
                dispatch( removeItem(id) )
        })
        .finally(() => {
            callBack()
            dispatch(setLoading(false))
        })
}